module.exports = __webpack_public_path__ + "img/hookah_3.0dad50eb.png";